/* One delegated controller; native modal dialog supplies an inert background
   and Escape. Keep Tab inside even when the close button is the only control.
   Existing variant radios remain authoritative. */
(function () {
  if (window.pfConditionDialogBound) return;
  window.pfConditionDialogBound = true;
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var dialog = document.querySelector('dialog[data-condition-dialog][open]');
    if (!dialog) return;
    var controls = Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]'))
      .filter(function (element) { return element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden'; });
    var first = controls[0], last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-condition-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-condition-open'));
      if (!dialog || dialog.open) return;
      var selected = document.querySelector('.pf-pdp__option-group[data-option-type="condition"] input:checked');
      // The shared menu/collection dialog has no "selected condition" fields.
      if (selected && dialog.querySelector('[data-condition-selected]')) {
        dialog.querySelector('[data-condition-selected]').textContent = selected.value;
        dialog.querySelectorAll('[data-condition-example]').forEach(function (example) {
          var current = example.getAttribute('data-condition-example') === selected.value;
          example.classList.toggle('is-current', current);
          example.querySelector('.pf-condition-current').hidden = !current;
        });
      }
      if (opener.tagName === 'A') event.preventDefault(); // link fallback: zonder JavaScript naar de conditiepagina
      dialog.pfOpener = opener;
      dialog.showModal();
      document.body.classList.add('pf-condition-open');
      dialog.querySelector('[data-condition-close]').focus();
      return;
    }
    var close = event.target.closest('[data-condition-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog[data-condition-dialog]')) {
      var rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', function (event) {
    if (!event.target.matches('dialog[data-condition-dialog]')) return;
    document.body.classList.remove('pf-condition-open');
    if (event.target.pfOpener && event.target.pfOpener.isConnected) event.target.pfOpener.focus();
  }, true);
})();
